import React from 'react'
import userImg from '../../assets/images/profile-pic.jpg'

const About = () => {
    return (
        <section id="about">  

            <div className="row section-intro" data-aos="zoom-in">
                <div className="col-twelve">

                    <h5>About me</h5>
                    <h1>Let me introduce myself.</h1>

                    <div className="intro-info">

                        <img src={userImg} alt="Profile Picture" />

                        <p className="lead">
                            I'm Mary Rojas, a passionate Front-end UI Developer with over 6+ years of experience creating websites using 
                            JavaScript frameworks (ReactJS), HTML5, and CSS (TailwindCSS, Bootstrap) 
                            to build all aspects of the user experience and user interface.
                        </p>
                    </div>   			

                </div>   		
            </div>

            <div className="row about-content" data-aos="zoom-in">

                <div className="col-twelve tab-full">

                    <h3>Profile</h3>
                    <p>
                        Experience in web development with emphasis on HTML5, CSS, SASS, TailwindCSS, Boostrap, JSON, JavaScript, jQuery, 
                        ReactJS with Redux/Hooks, MySQL, Git, Webpack, PHP Laravel (Blade Templates), CMS(WordPress). Working on Scrumwise, Jira, Productive.
                    </p>

                </div>

                <div className="col-six tab-full">
                    <ul className="info-list">
                        <li>
                            <strong>Fullname:</strong>
                            <span>Mary Rojas</span>
                        </li>
                        <li>
                            <strong>Country:</strong>
                            <span>Venezuela</span>
                        </li>
                        <li>
                            <strong>Job:</strong>
                            <span>Frontend UI Developer</span>
                        </li>
                        <li>
                            <strong>Website:</strong>
                            <span><a target="_blank" rel="noreferrer" href="https://www.behance.net/mcrojas">www.behance.net/mcrojas</a></span>
                        </li>
                        <li>
                            <strong>Email:</strong>
                            <span><a href="mailto:mcrojas09@gmail.com">mcrojas09@gmail.com</a></span>
                        </li>

                    </ul>
                </div>

                <div className="col-six tab-full">

                    <h3>Skills</h3>
                        <ul className="skill-bars">
                            <li>
                                <div className="progress percent90"><span>90%</span></div>
                                <strong>HTML5</strong>
                            </li>
                            <li>
                                <div className="progress percent85"><span>85%</span></div>
                                <strong>CSS3</strong>
                            </li>
                            <li>
                                <div className="progress percent85"><span>85%</span></div>
                                <strong>WordPress</strong>
                            </li>
                            <li>
                                <div className="progress percent70"><span>70%</span></div>
                                <strong>ReactJS</strong>
                            </li>
                        </ul>

                </div>

            </div>

            <div className="row button-section" data-aos="zoom-in">
                <div className="col-twelve">
                    <a href="https://media-exp3.licdn.com/dms/document/C4E2DAQErI710wSo_8A/profile-treasury-document-pdf-analyzed/0/1617990675063?e=1623171600&v=beta&t=7yC5wVA82Ba_nLSJtW3DSOAJ-aIVNHZPWx-P7U0TLVU" rel="noreferrer" title="Download CV" className="button button-primary" target="_blank">Download CV</a>
                </div>   		
            </div>

        </section>
    )
}

export default About
